if (!customElements.get("accordion-element")) {
  customElements.define(
    "accordion-element",
    class Accordion extends HTMLElement {
      constructor() {
        super()

        this.trigger = this.querySelector("[data-accordion-trigger]")
        this.content = this.querySelector("[role='region']")

        if (!this.trigger || !this.content) {
          console.error("Accordion element missing trigger or content.")
          return
        }

        this.trigger.addEventListener("click", this.onToggle.bind(this))
        this.trigger.addEventListener("keydown", this.onTriggerKeydown.bind(this))

        // Check the initial state and open if required
        if (this.dataset.state === "open") {
          this.open()
        } else {
          this.close()
        }
      }

      onTriggerKeydown(event) {
        if (event.key === "Enter" || event.key === "Space") {
          event.preventDefault()
          this.toggle()
        }
      }

      onToggle() {
        if (this.dataset.state === "closed") {
          this.open()
        } else {
          this.close()
        }
      }

      open() {
        this.dataset.state = "open"
        this.trigger.setAttribute("aria-expanded", "true")
        this.trigger.setAttribute("data-state", "open")
        this.content.style.maxHeight = this.content.scrollHeight + "px"
        this.content.setAttribute("aria-hidden", "false")
        this.content.setAttribute("data-state", "open")
      }

      close() {
        this.dataset.state = "closed"
        this.trigger.setAttribute("aria-expanded", "false")
        this.trigger.setAttribute("data-state", "closed")
        this.content.style.maxHeight = "0px"
        this.content.setAttribute("aria-hidden", "true")
        this.content.setAttribute("data-state", "closed")
      }
    }
  )
}
